module.exports = __webpack_public_path__ + "img/dakong2.c44e6912.png";